module.exports = __webpack_public_path__ + "img/Ranger.f8870f71.png";